<template>
  <div>
    <h3>Action for mass attendee:</h3>
    <div  v-if="sellectedAttendees.length">
      <h5>
        Quantity of chosen attendees: {{sellectedAttendees.length}}
      </h5>
      <v-btn color="primary" flat @click="resetCheckboxes">Reset selected items</v-btn>
    </div>
    <v-layout pa-2 wrap row>
        <v-chip
          class="mx-3"
          color="indigo"
          text-color="white"
          @click="sendConfirmationEmail"
        >
        <v-avatar>
          <v-icon>email</v-icon>
        </v-avatar>
          Send Confirmation Email
        </v-chip>

        <div
          v-for="button in actionsButtons"
          :key="`button-${button.state}`"
        >
          <v-chip
            class="mx-3"
            :color="button.color"
            text-color="white"
            @click="setActionStateAndOpenModal(button.state)"
          >
          <v-avatar>
            <v-icon>{{ button.icon }}</v-icon>
          </v-avatar>
            {{ button.name }}
          </v-chip>
        </div>

    </v-layout>

    <v-dialog
      persistent
      v-model="dialogModal"
      max-width="500px"
    >
      <v-card>
        <v-card-text>

          <div v-if="isPartForChooseActivity">
            <h3>Choose activity for attendees</h3>
            <v-select
              :items="predefinedActivity"
              v-model="dataForPayload.selectedActivityId"
              label="Select activity"
              single-line
              item-text="title"
              item-value="id"
            />
          </div>

          <div v-if="checkActionsState('setStatus')">
            <h3>Set status</h3>
            <v-select
              :items="statusdisplayNameWithoutCount"
              v-model="dataForPayload.selectedStatus"
              label="Select status"
              single-line
              item-text="displayName"
              item-value="registrationStatus"
            />
            <p v-if="isSelectedCompletedForAttendeePendingPackageSelection" class="red--text text--darken-1">
              Some selected attendees have status "Pending Package Selection".
              Remove them to save the changes.
            </p>
          </div>
          <div v-if="checkActionsState('setInfo')">
            <h3>Set info</h3>

            <content-field
              label="Company"
              v-model="dataForPayload.company"
            />
            <content-field
              label="Booth"
              v-model="dataForPayload.booth"
            />
          </div>
          <div v-if="isPartSetMessageLimit">
            <h3>Set message limit attendees</h3>
            <content-field
              label="Set message limit"
              v-model="dataForPayload.messageLimit"
            />
          </div>
          <div v-if="checkActionsState('setIndustry')">
            <h3>Set industry</h3>
            <v-select
              :items="categoriesList"
              v-model="dataForPayload.selectedCategoryId"
              label="Select category"
              single-line
              item-text="name"
              item-value="id"
            />
          </div>
          <div v-if="checkActionsState('setTypeRegulars')">
            <h3>Set type regulars</h3>
            <v-select
              :items="regularAttendeeType"
              v-model="dataForPayload.selectedTypeId"
              label="Select type"
              single-line
              item-text="title"
              item-value="id"
            />
          </div>
          <div v-if="checkActionsState('setTypeVips')">
            <h3>Set type vips</h3>
            <v-select
              :items="regularAttendeeType"
              v-model="dataForPayload.selectedTypeId"
              label="Select type"
              single-line
              item-text="title"
              item-value="id"
            />

            <v-select
              :items="sponsorsTypeList"
              v-model="dataForPayload.selectedSponsorTypeId"
              label="Select sponsor type"
              single-line
              item-text="title"
              item-value="id"
            />
          </div>
          <div v-if="checkActionsState('killerFeatureTagSearchHide')">
            <h3>Attendee will be removed from search results</h3>
            <v-switch
              class="mt-4"
              :label="searchRemoveActionLabel"
              v-model="dataForPayload.boolean"
            />
          </div>
          <div v-if="checkActionsState('hideEnvelope')">
            <div>
              <p><v-icon large color="red darken-2" class="mr-3">email</v-icon>Ability to receive messages</p>
              <v-switch
                class="mt-4"
                :label="receiveMessagesActionLabel"
                v-model="dataForPayload.boolean"
              />
            </div>
          </div>
          <div v-if="checkActionsState('requestForPhoto')">
            <div>
              <p class="text-xs-center"><v-icon large color="purple darken-2">face</v-icon></p>
              <v-toolbar-title class="text-xs-center">Send photo request?</v-toolbar-title>
            </div>
          </div>
          <div v-if="checkActionsState('addToBlacklist')">
            <div>
              <p class="text-xs-center"><v-icon large color="purple darken-2">cancel</v-icon></p>
              <v-toolbar-title class="text-xs-center">Add to blacklist?</v-toolbar-title>
            </div>
          </div>

          <div v-if="checkActionsState('sendReminders')">
            <div>
              <p class="text-xs-center"><v-icon large color="cyan darken-2">info</v-icon></p>
              <v-toolbar-title class="text-xs-center">Send reminders?</v-toolbar-title>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-btn
            class="green white--text"
            @click="sendRequest"
            :disabled="isSelectedCompletedForAttendeePendingPackageSelection"
          >
            Ok
          </v-btn>
          <v-btn class="green white--text" @click="resetState">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex'
import { map, prop, clone } from 'ramda'
import ContentField from '@/components/shared/ContentField/index.vue'

export default {
  name: 'massAttendeeActions',
  components: {
    ContentField
  },
  props: {
    sellectedAttendees: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      dialogModal: false,
      actionsState: '',
      dataForPayload: {},
      actionsButtons: [
        {
          color: 'orange',
          state: 'setActivitiesRegular',
          icon: 'exposure_plus_2',
          name: 'Set activities Regular'
        },
        {
          color: 'primary',
          state: 'setActivitiesVip',
          icon: 'exposure_plus_2',
          name: 'Set activities vip'
        },
        {
          color: 'green',
          state: 'unsetActivitiesRegular',
          icon: 'exposure_neg_2',
          name: 'Unset activities regular'
        },
        {
          color: 'teal',
          state: 'unsetActivitiesVip',
          icon: 'exposure_neg_2',
          name: 'Unset activities vip'
        },
        {
          color: 'secondary',
          state: 'setStatus',
          icon: 'gavel',
          name: 'Set status'
        },
        {
          color: 'red',
          state: 'setInfo',
          icon: 'info',
          name: 'Set info'
        },
        {
          color: 'pink',
          state: 'setMessageLimitRegulars',
          icon: 'message',
          name: 'Set message limit regulars'
        },
        {
          color: 'lime darken-4',
          state: 'setMessageLimitVips',
          icon: 'message',
          name: 'Set message limit vips'
        },
        {
          color: 'grey darken-1',
          state: 'setIndustry',
          icon: 'category',
          name: 'Set industry'
        },
        {
          color: 'yellow darken-4',
          state: 'setTypeRegulars',
          icon: 'title',
          name: 'Set type regulars'
        },
        {
          color: 'cyan',
          state: 'setTypeVips',
          icon: 'title',
          name: 'Set type vips'
        },
        {
          color: 'brown',
          state: 'killerFeatureTagSearchHide',
          icon: 'search',
          name: 'Attendee will be removed/added from search results'
        },
        {
          color: 'blue-grey',
          state: 'hideEnvelope',
          icon: 'send',
          name: 'Attendees can receive message'
        },
        {
          color: 'purple',
          state: 'requestForPhoto',
          icon: 'face',
          name: 'Send request for photo'
        },
         {
          color: 'cyan',
          state: 'sendReminders',
          icon: 'info',
          name: 'Send reminders'
        },
        {
          color: 'red',
          state: 'addToBlacklist',
          icon: 'cancel',
          name: 'Add to blacklist'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'predefinedActivity',
      'statusDisplayNames',
      'categoriesList',
      'regularAttendeeType',
      'sponsorsTypeList'
    ]),
    getIdsSelectedAttendees () {
      const idsSelectedAttendees =  map(prop('id'), this.sellectedAttendees)
      return idsSelectedAttendees
    },
    isPartForChooseActivity () {
      return this.checkActionsState('setActivitiesRegular') || this.checkActionsState('setActivitiesVip') || this.checkActionsState('unsetActivitiesRegular') || this.checkActionsState('unsetActivitiesVip')
    },
    isPartSetMessageLimit () {
      return this.checkActionsState('setMessageLimitRegulars') || this.checkActionsState('setMessageLimitVips')
    },
    isAttendeesWithPendingPackageSelectionStatus () {
      return !!this.sellectedAttendees.filter(attendee => attendee.registrationStatus === 'PendingPackageSelection').length
    },
    isSelectedStatusCompleted () {
      return this.dataForPayload.selectedStatus === 'Completed'
    },
    isSelectedCompletedForAttendeePendingPackageSelection () {
      return this.isAttendeesWithPendingPackageSelectionStatus && this.isSelectedStatusCompleted
    },
    statusdisplayNameWithoutCount () {
      const arr = clone(this.statusDisplayNames)
      arr.map((item, index) =>  {
        item.displayName = item.displayName.split(':')[0]
      })
      return arr
    },
    receiveMessagesActionLabel () {
      return this.dataForPayload.boolean === true ? 'Enable' : 'Disable'
    },
    searchRemoveActionLabel () {
      return this.dataForPayload.boolean === true ?  'Removed' :'Show'
    }
  },
  methods: {
    ...mapActions([
      'resendConfirmationEmail',
      'requestForPhoto',
      'setActivitiesRegular',
      'setActivitiesVip',
      'unsetActivitiesRegular',
      'unsetActivitiesVip',
      'setStatus',
      'setInfo',
      'setMessageLimitRegulars',
      'setMessageLimitVips',
      'setIndustry',
      'setTypeRegulars',
      'setTypeVips',
      'killerFeatureTagSearchHide',
      'hideEnvelope',
      'getPredefinedActivity',
      'addToBlacklist',
      'fetchSponsorTypesList',
      'sendReminders'
    ]),
    resetSelectedItems () {
      this.$emit('resetSelected')
    },
    resetCheckboxes () {
      this.$emit('resetCheckboxes')
    },
    checkActionsState (state) {
      return this.actionsState === state
    },
    async sendConfirmationEmail () {
      const payload = {
        ids: this.getIdsSelectedAttendees
      }
      try {
        await this.resendConfirmationEmail(payload)
        this.resetSelectedItems ()
      } catch (err) {
        console.error(err)
      }
    },
    setActionStateAndOpenModal (state) {
      this.dataForPayload = clone({
        selectedActivityId: '',
        selectedStatus: '',
        selectedCategoryId: '',
        selectedTypeId: '',
        selectedSponsorTypeId: '',
        boolean: false,
        company: '',
        booth: '',
        messageLimit: null
      })
      this.dialogModal = true
      this.actionsState = state
    },
    resetState () {
      this.dialogModal = false
      this.actionsState = ''
    },
    async sendRequest () {
      // TODO: need refactoring
      let payload = {
        ids: this.getIdsSelectedAttendees
      }
      let updateTrigger = ''
      if (this.isPartForChooseActivity) payload.activityId = this.dataForPayload.selectedActivityId
      if (this.checkActionsState('setStatus')) {
        payload.status = this.dataForPayload.selectedStatus
        updateTrigger = 'updateStatus'
      }
      if (this.checkActionsState('setInfo')) {
        payload.company = this.dataForPayload.company
        payload.booth = this.dataForPayload.booth
      }
      if (this.isPartSetMessageLimit) payload.limit = this.dataForPayload.messageLimit
      if (this.checkActionsState('setIndustry')) payload.categoryId = this.dataForPayload.selectedCategoryId
      if (this.checkActionsState('setTypeRegulars')) payload.attendeeTypeId = this.dataForPayload.selectedTypeId
      if (this.checkActionsState('setTypeVips')) {
        payload.attendeeTypeId = this.dataForPayload.selectedTypeId
        payload.sponsorTypeId = this.dataForPayload.selectedSponsorTypeId
      }
      if (this.checkActionsState('killerFeatureTagSearchHide')) payload.isRemovedFromKillerFeatureSearch = this.dataForPayload.boolean
      if (this.checkActionsState('hideEnvelope')) payload.canReceiveMessages = this.dataForPayload.boolean
      try {
        await this[this.actionsState](payload)
        this.$bus.$emit('reloadTable', updateTrigger)
      } catch (err) {
        console.error(err)
      }
      this.resetState()
      this.resetSelectedItems ()
    }
  },
  async mounted () {
    await this.getPredefinedActivity()
    await this.fetchSponsorTypesList()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AllAttendee/massAttendeeActions.vue